import { render } from "./DescriptionText.vue?vue&type=template&id=2c9d8681&scoped=true"
import script from "./DescriptionText.vue?vue&type=script&lang=js"
export * from "./DescriptionText.vue?vue&type=script&lang=js"

import "./DescriptionText.vue?vue&type=style&index=0&id=2c9d8681&scoped=true&lang=css"

import exportComponent from "/Users/gabrielvoirol/git_projects/df_wpheadless/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c9d8681"]])

export default __exports__